import { Component } from '@theme/component';

/** Keeps server-rendered prices aligned with the UTC sale window, including cached pages. */
class ScheduledPromotionPrice extends Component {
  #timer;
  #abortController;

  connectedCallback() {
    super.connectedCallback();
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const options = { signal: this.#abortController.signal };
    document.addEventListener('visibilitychange', this.#sync, options);
    window.addEventListener('pageshow', this.#sync, options);
    // Fragment insertion can connect the element before its template children are parsed.
    queueMicrotask(() => {
      if (this.isConnected) this.#sync();
    });
  }

  updatedCallback() {
    super.updatedCallback();
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.#timer);
    this.#abortController?.abort();
  }

  #sync = () => {
    clearTimeout(this.#timer);
    const start = Number(this.dataset.start);
    const end = Number(this.dataset.end);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;

    const now = Date.now();
    const active = now >= start && now < end;
    if (this.dataset.active !== String(active)) {
      const template = this.querySelector(active ? '[data-sale-price]' : '[data-regular-price]');
      const content = this.querySelector('[data-price-content]');
      if (!(template instanceof HTMLTemplateElement) || !content) return;
      content.replaceChildren(template.content.cloneNode(true));
      this.dataset.active = String(active);
    }

    const boundary = now < start ? start : end;
    if (now < boundary) {
      // A bounded timeout avoids overflow and also rechecks after device clock changes.
      this.#timer = setTimeout(this.#sync, Math.min(boundary - now + 25, 60_000));
    }
  };
}

if (!customElements.get('scheduled-promotion-price')) {
  customElements.define('scheduled-promotion-price', ScheduledPromotionPrice);
}
